import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUndoCancelSubscriptionPlanMutation = createMutationHook(
  SaasApiClient.undoCancelSubscriptionPlan,
  {
    mutationKey: ['undoCancelSubscriptionPlanMutation'],
  },
)
